import { Component } from 'react';
import Media from 'react-media';
import { MQ_LARGE, MQ_MEDIUM, MQ_SMALL } from './Breakpoints';

class IwMedia extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getMediaValue(value, fromTo) {
        let finalValue = value;
        if (value === 'small') finalValue = MQ_SMALL;
        if (value === 'medium') finalValue = MQ_MEDIUM;
        if (value === 'large') finalValue = MQ_LARGE;
        if (typeof value === 'string' && fromTo === 'to') finalValue -= 1;
        return finalValue;
    }

    buildQuery(fromValue, toValue) {
        let query;
        if (fromValue && typeof toValue === 'undefined') {
            query = `(min-width: ${fromValue}px)`;
        } else if (typeof fromValue === 'undefined' && toValue) {
            query = `(max-width: ${toValue}px)`;
        } else if (fromValue && toValue) {
            query = `(min-width: ${fromValue}px) and (max-width: ${toValue}px)`;
        } else {
            return new Error(
                'IwMedia must have at least a "from" or a "to" prop'
            );
        }

        return query;
    }

    renderChildren() {
        const { from, to, children } = this.props;
        let fromValue, toValue;

        if (from) {
            fromValue = this.getMediaValue(from, 'from');
        } else {
            fromValue = from;
        }

        if (to) {
            toValue = this.getMediaValue(to, 'to');
        } else {
            toValue = to;
        }

        const query = this.buildQuery(fromValue, toValue);

        return query instanceof Error ? (
            `${query.name}: ${query.message}`
        ) : (
            <Media query={query}>
                {(matches) => (matches ? <>{children}</> : null)}
            </Media>
        );
    }

    render() {
        return this.renderChildren();
    }
}

// eslint-disable-next-line import/no-default-export
export default IwMedia;
